import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnPencilEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M13.497 21.193h7.253M10.77 6.75l5.453 4.187M12.53 4.545a2.245 2.245 0 0 1 3.116-.303l1.733 1.347a2.14 2.14 0 0 1 .72 2.984c-.034.054-9.537 11.942-9.537 11.942a1.7 1.7 0 0 1-1.31.632l-3.638.046-.82-3.47c-.115-.489 0-1.001.316-1.396z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnPencilEdit;
